import { DomainBox } from "@/components/shared/DomainBox";
import { Domain } from "@/types/domain";

interface EducationDomainSectionProps {
  title: string;
  domains: Domain[];
  domainKBs?: any[];
}

const getEducationKnowledgeBases = (symbol: string) => {
  const symbolToSolutionMap: Record<string, string[]> = {
    "K12": ["edu-001", "edu-002"],
    "HiEd": ["edu-004", "edu-003"],
    "StEd": ["edu-001", "edu-008"],
    "FedEd": ["edu-008", "edu-007"],
    "WkDev": ["edu-005", "edu-006"],
    "DigiAI": ["edu-003", "edu-007"],
    "TchPD": ["edu-010", "edu-001"],
    "EqAcc": ["edu-001", "edu-003"],
    "StHlt": ["edu-009", "edu-001"],
    "AltLrn": ["edu-005", "edu-006"],
  };

  const solutionIds = symbolToSolutionMap[symbol] || ["edu-001", "edu-002"];

  return [
    { title: "Domain Knowledge Base", url: `/channel-solutions?channel=education&demo=true&id=${solutionIds[0]}` },
    { title: "Best Practices Guide", url: `/channel-solutions?channel=education&demo=true&id=${solutionIds[1]}` },
  ];
};

export const EducationDomainSection = ({ title, domains, domainKBs = [] }: EducationDomainSectionProps) => {
  const getKBCount = (domainName: string) => {
    if (!domainKBs || domainKBs.length === 0) return 0;
    return domainKBs.filter(kb => kb.domains?.name === domainName).length;
  };

  return (
    <div className="mb-8">
      <h2 className="text-xl font-semibold mb-4 text-black">{title}</h2>
      <div className="grid grid-cols-3 gap-4">
        {domains.map((domain) => (
          <DomainBox
            key={domain.symbol + domain.name}
            domain={domain}
            getKnowledgeBases={getEducationKnowledgeBases}
            kbCount={getKBCount(domain.name)}
          />
        ))}
      </div>
    </div>
  );
};
